var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageCaption(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7331 -0.000976562H2.27859C1.02859 -0.000976562 0.00585938 1.04902 0.00585938 2.33236V18.6657C0.00585938 19.949 1.02859 20.999 2.27859 20.999H22.7331C23.9831 20.999 25.0059 19.949 25.0059 18.6657V2.33236C25.0059 1.04902 23.9831 -0.000976562 22.7331 -0.000976562ZM11.3695 9.33236H3.41495C2.78995 9.33236 2.27859 8.80736 2.27859 8.16569C2.27859 7.52402 2.78995 6.99902 3.41495 6.99902H11.3695C11.9945 6.99902 12.5059 7.52402 12.5059 8.16569C12.5059 8.80736 11.9945 9.33236 11.3695 9.33236ZM11.3695 4.66569H3.41495C2.78995 4.66569 2.27859 4.14069 2.27859 3.49902C2.27859 2.85736 2.78995 2.33236 3.41495 2.33236H11.3695C11.9945 2.33236 12.5059 2.85736 12.5059 3.49902C12.5059 4.14069 11.9945 4.66569 11.3695 4.66569Z",
    fill: "#A8A7CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageCaption);
export default __webpack_public_path__ + "static/media/image-caption.bc5aad39d738ff5e94dbaaa8a32d60e9.svg";
export { ForwardRef as ReactComponent };